/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./chains.vue?vue&type=template&id=28d0dbaf&scoped=true"
import script from "./chains.vue?vue&type=script&lang=js"
export * from "./chains.vue?vue&type=script&lang=js"
import style0 from "./chains.vue?vue&type=style&index=0&id=28d0dbaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d0dbaf",
  null
  
)

export default component.exports